import React, { useEffect, useState } from 'react'
import DefaultImg from "../../images/default_avatar.jpg"
import { formatWhatsAppNumber } from '../../../utils/whatsappLinkFormater'
import { formatDbDate } from '../../../utils/dateFormater'
import { adminUpdateUserCredentialsAction, allowEditingAction, clearErrors, userDetailsAction } from '../../../redux/actions/userActions'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import Loader from '../../loader/loader'
import { Link } from "react-router-dom"
import { ADMIN_UPDATE_USER_CREDENTIALS_RESET } from '../../../redux/constants/userConstant'

const Profile = ({ user, setshowPopup }) => {

    const dispatch = useDispatch()

    const [copied, setCopied] = useState(false);
    const [newName, setNewName] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [newPassword, setNewPassword] = useState("");

    const { loading, error, message } = useSelector((state) => state.allowEditing)
    const { loading: adminLoading, error: adminError, success: adminSuccess, message: adminMessage } = useSelector((state) => state.inviteUser) // Using inviteUser reducer as per current setup
    const { user: loggedInUser } = useSelector((state) => state.verifyEmailStore)





    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };


    const handleProfileEditing = () => {

        dispatch(allowEditingAction(user?.id))

    }

    const handleUpdateCredentials = (type) => {
        if (type === 'name' && !newName) return toast.error("Please enter a name");
        if (type === 'email' && !newEmail) return toast.error("Please enter a new email");
        if (type === 'password' && !newPassword) return toast.error("Please enter a new password");

        const payload = { user_id: user?.id };
        if (type === 'name') payload.name = newName;
        if (type === 'email') payload.email = newEmail;
        if (type === 'password') payload.password = newPassword;

        dispatch(adminUpdateUserCredentialsAction(payload));
    }


    useEffect(() => {

        if (error) {
            dispatch(clearErrors())
        }

        if (adminError) {
            dispatch(clearErrors())
        }

        if (message) {
            dispatch({ type: "ALLOW_EDITING_RESET" })
            dispatch(userDetailsAction(user?.id))
            setshowPopup(false)
        }

        if (adminSuccess) {
            dispatch({ type: ADMIN_UPDATE_USER_CREDENTIALS_RESET })
            dispatch(userDetailsAction(user?.id))
            setNewName("")
            setNewEmail("")
            setNewPassword("")
        }


    }, [error, adminError, adminSuccess, adminMessage, message, dispatch, user?.id, setshowPopup])






    return (
        <div className="bg-white p-[2vmax] rounded-xl border border-gray-100 shadow-sm">
            {loading && <Loader />}
            
            {/* Header */}
            <div className="flex justify-between items-center mb-[2vmax]">
                <h3 className="text-[1.5vmax] font-bold text-gray-800">Personal Information</h3>
                <span className={`px-[1vmax] py-[0.3vmax] rounded-full text-[0.8vmax] font-bold uppercase tracking-wider 
                    ${user?.status === "ACTIVE" ? "text-emerald-600 bg-emerald-50" :
                      user?.status === "BLOCKED" ? "text-rose-600 bg-rose-50" : "text-amber-600 bg-amber-50"}`}
                >
                    {user?.status}
                </span>
            </div>

            {/* Profile Section */}
            <div className="flex gap-[1.5vmax] items-center mb-[2vmax]">
                <div className="w-[6vmax] h-[6vmax] p-[0.2vmax] bg-white border border-gray-100 rounded-full shadow-sm">
                    <img src={user?.avatar_url || DefaultImg} alt="" className='object-cover w-full h-full rounded-full' />
                </div>
                <div className="flex flex-col gap-[0.3vmax]">
                    <h4 className="text-[1.3vmax] font-bold text-gray-800">{user?.name}</h4>
                    <div className="text-[0.75vmax] font-bold uppercase tracking-wider text-indigo-600 bg-indigo-50 w-fit p-[0.2vmax_0.6vmax] rounded">{user?.role}</div>
                </div>
            </div>

            {/* Contact Info */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-[1.5vmax] mb-[1.5vmax]">
                <div className="flex gap-[1vmax] items-center bg-gray-50 p-[1vmax] rounded-lg">
                    <div className="w-[2.5vmax] h-[2.5vmax] bg-indigo-50 text-indigo-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="fa-regular fa-envelope text-[1.2vmax]"></i>
                    </div>
                    <div className="flex flex-col">
                        <span className="text-[0.8vmax] text-gray-400 font-medium">Email</span>
                        <span className='text-gray-700 font-bold text-[0.9vmax]' >{user?.email}</span>
                    </div>
                </div>

                <div className="flex gap-[1vmax] items-center bg-gray-50 p-[1vmax] rounded-lg">
                    <div className="w-[2.5vmax] h-[2.5vmax] bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="fa-solid fa-phone text-[1.2vmax]"></i>
                    </div>
                    <div className="flex flex-col">
                        <span className="text-[0.8vmax] text-gray-400 font-medium">Phone</span>
                        <span className='text-gray-700 font-bold text-[0.9vmax]' >{user?.country_code} {user?.phone_number || "N/A"}</span>
                    </div>
                </div>

                <div className="flex gap-[1vmax] items-center bg-gray-50 p-[1vmax] rounded-lg">
                    <div className="w-[2.5vmax] h-[2.5vmax] bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="fa-brands fa-whatsapp text-[1.4vmax]"></i>
                    </div>
                    <div className="flex flex-col">
                        <span className="text-[0.8vmax] text-gray-400 font-medium">WhatsApp</span>
                        {user?.phone_number ? (
                            <a 
                                href={formatWhatsAppNumber(user?.country_code, user?.phone_number)} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="flex items-center gap-1 text-emerald-600 hover:text-emerald-700 font-bold text-[0.9vmax]"
                            >
                                <i className="fa-brands fa-whatsapp text-[1.2vmax]"></i>
                                <span>Open Chat</span>
                            </a>
                        ) : (
                            <span className='text-gray-400 text-[0.9vmax]' >N/A</span>
                        )}
                    </div>
                </div>
            </div>

            {/* Address (Full Width) */}
            <div className="flex gap-[1vmax] items-center bg-gray-50 p-[1vmax] rounded-lg mb-[2vmax]">
                <div className="w-[2.5vmax] h-[2.5vmax] bg-amber-50 text-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-earth-asia text-[1.2vmax]"></i>
                </div>
                <div className="flex flex-col flex-1">
                    <span className="text-[0.8vmax] text-gray-400 font-medium">Address</span>
                    <span className='text-gray-700 font-bold text-[0.9vmax]' >
                        {user?.street_address ? `${user.street_address}, ${user.city}, ${user.state}, ${user.country}` : "N/A"}
                    </span>
                </div>
            </div>

            {/* Account Details Grid */}
            <div className="border-t border-gray-100 pt-[2vmax] mb-[2vmax]">
                <h4 className="text-[1.1vmax] font-bold text-gray-800 mb-[1.5vmax]">Account Details</h4>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-[1.5vmax]">
                    {user?.role === "PMM" && (
                        <div>
                            <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>User ID</span>
                            <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{String(user?.pmm_id).padStart(2, '0')}</span>
                        </div>
                    )}
                    <div>
                        <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>{user?.role !== "PMM" ? "User / Referral ID" : "Referral ID"}</span>
                        <div className="flex items-center gap-2 mt-[0.3vmax]">
                            <span className='text-[1vmax] text-gray-700 font-bold'>{user?.id}</span>
                            <button onClick={() => handleCopy(user?.id)} className="text-gray-400 hover:text-indigo-600" title={copied ? "Copied" : "Copy"}>
                                <i className={`fa-regular ${copied ? "fa-circle-check text-emerald-500" : "fa-copy"}`}></i>
                            </button>
                        </div>
                    </div>
                    <div>
                        <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>Referred By</span>
                        <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.referal_name || "N/A"}</span>
                    </div>
                    <div>
                        <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>Joined</span>
                        <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{formatDbDate(user?.created_at)}</span>
                    </div>

                    {user?.role === "ADMIN" && (
                        <>
                            <div>
                                <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>PMM Count</span>
                                <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.pmm_count || 0}</span>
                            </div>
                            <div>
                                <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>PM Count</span>
                                <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.pm_count || 0}</span>
                            </div>
                        </>
                    )}

                    {user?.role === "PMM" && (
                        <div>
                            <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>Products</span>
                            <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.products_count || 0}</span>
                        </div>
                    )}

                    {(user?.role === "PM" || user?.role === "PMM") && (
                        <>
                            <div>
                                <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>Orders</span>
                                <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.role === "PMM" ? user?.pmm_orders_count : user?.pm_orders_count}</span>
                            </div>
                            <div>
                                <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>Admin</span>
                                <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.admin_name || <i className="text-gray-400 font-normal">Not Assigned</i>}</span>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Bank Details */}
            <div className="border-t border-gray-100 pt-[2vmax] mb-[2vmax]">
                <h4 className="text-[1.1vmax] font-bold text-gray-800 mb-[1.5vmax]">Bank Details</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-[1.5vmax]">
                    <div>
                        <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>Bank Name</span>
                        <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.bank_name || "N/A"}</span>
                    </div>
                    <div>
                        <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>Account Holder Name</span>
                        <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.account_title || "N/A"}</span>
                    </div>
                    <div>
                        <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>Account Number / IBAN</span>
                        <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.account_number || "N/A"}</span>
                    </div>
                </div>
            </div>

            {/* CNIC Information */}
            <div className="border-t border-gray-100 pt-[2vmax] mb-[2vmax]">
                <h4 className="text-[1.1vmax] font-bold text-gray-800 mb-[1.5vmax]">CNIC Information</h4>
                <div className="mb-[1.5vmax]">
                    <span className='text-[0.8vmax] text-gray-400 uppercase font-bold'>CNIC Number</span>
                    <span className='text-[1vmax] text-gray-700 font-bold block mt-[0.3vmax]'>{user?.cnic_number || "N/A"}</span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.5vmax]">
                    <div className="bg-gray-50 p-[0.5vmax] rounded-lg border border-gray-100">
                        <img src={user?.cnic_front_url} alt="CNIC Front" className='w-full rounded-lg object-cover' />
                    </div>
                    <div className="bg-gray-50 p-[0.5vmax] rounded-lg border border-gray-100">
                        <img src={user?.cnic_back_url} alt="CNIC Back" className='w-full rounded-lg object-cover' />
                    </div>
                </div>
            </div>

            {/* Admin Security Actions */}
            {(loggedInUser?.role === "SUPER_ADMIN" || 
              (loggedInUser?.role === "ADMIN" && user?.role === "PMM" && user?.admin_id === loggedInUser?.id)) && (
                <div className="border-t border-gray-100 pt-[2vmax] mb-[2vmax]">
                    <h4 className="text-[1.1vmax] font-bold text-rose-600 mb-[1.5vmax] flex items-center gap-2">
                        <i className="fa-solid fa-shield-halved"></i> Admin Security Actions
                    </h4>
                    <div className="flex flex-col gap-[1.5vmax] bg-rose-50/30 p-[1.5vmax] rounded-xl border border-rose-100">
                        {/* Change Name */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-[1vmax] pb-[1vmax] border-b border-rose-100/50">
                            <div className="flex flex-col gap-[0.3vmax]">
                                <label className="text-[0.9vmax] font-bold text-gray-700">Display Name</label>
                                <p className="text-[0.75vmax] text-gray-500">Update the user's full name</p>
                            </div>
                            <div className="flex gap-[0.5vmax] w-full md:w-[60%]">
                                <input 
                                    type="text" 
                                    className="flex-1 p-[0.7vmax_1.2vmax] rounded-lg border border-gray-200 text-[0.9vmax] focus:border-indigo-500 outline-none transition-all bg-white"
                                    placeholder="Enter Full Name"
                                    value={newName}
                                    onChange={(e) => setNewName(e.target.value)}
                                />
                                <button 
                                    className="bg-indigo-600 text-white p-[0.7vmax_1.8vmax] rounded-lg font-bold text-[0.85vmax] hover:bg-indigo-700 active:scale-95 transition-all disabled:opacity-50 whitespace-nowrap"
                                    onClick={() => handleUpdateCredentials('name')}
                                    disabled={adminLoading}
                                >
                                    Update Name
                                </button>
                            </div>
                        </div>

                        {/* Change Email */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-[1vmax] pb-[1vmax] border-b border-rose-100/50">
                            <div className="flex flex-col gap-[0.3vmax]">
                                <label className="text-[0.9vmax] font-bold text-gray-700">Email Address</label>
                                <p className="text-[0.75vmax] text-gray-500">Change login email (must be unique)</p>
                            </div>
                            <div className="flex gap-[0.5vmax] w-full md:w-[60%]">
                                <input 
                                    type="email" 
                                    className="flex-1 p-[0.7vmax_1.2vmax] rounded-lg border border-gray-200 text-[0.9vmax] focus:border-indigo-500 outline-none transition-all bg-white"
                                    placeholder="New Email Address"
                                    value={newEmail}
                                    onChange={(e) => setNewEmail(e.target.value)}
                                />
                                <button 
                                    className="bg-indigo-600 text-white p-[0.7vmax_1.8vmax] rounded-lg font-bold text-[0.85vmax] hover:bg-indigo-700 active:scale-95 transition-all disabled:opacity-50 whitespace-nowrap"
                                    onClick={() => handleUpdateCredentials('email')}
                                    disabled={adminLoading}
                                >
                                    Update Email
                                </button>
                            </div>
                        </div>

                        {/* Change Password */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-[1vmax]">
                            <div className="flex flex-col gap-[0.3vmax]">
                                <label className="text-[0.9vmax] font-bold text-gray-700">Account Password</label>
                                <p className="text-[0.75vmax] text-gray-500">Reset user's password (min 8 chars)</p>
                            </div>
                            <div className="flex gap-[0.5vmax] w-full md:w-[60%]">
                                <input 
                                    type="text" 
                                    className="flex-1 p-[0.7vmax_1.2vmax] rounded-lg border border-gray-200 text-[0.9vmax] focus:border-rose-500 outline-none transition-all bg-white"
                                    placeholder="New Secure Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <button 
                                    className="bg-rose-600 text-white p-[0.7vmax_1.8vmax] rounded-lg font-bold text-[0.85vmax] hover:bg-rose-700 active:scale-95 transition-all disabled:opacity-50 whitespace-nowrap"
                                    onClick={() => handleUpdateCredentials('password')}
                                    disabled={adminLoading}
                                >
                                    Reset Password
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Actions */}
            {user?.status === "ACTIVE" && (
                <div className="border-t border-gray-100 pt-[2vmax]">
                    <h4 className="text-[1.1vmax] font-bold text-gray-800 mb-[1vmax]">Quick Actions</h4>
                    <div className="flex gap-[1vmax] flex-wrap">
                        {user?.role === "PMM" && (
                            <button 
                                className='px-[1.5vmax] py-[0.5vmax] rounded-lg text-[0.9vmax] font-bold text-white bg-indigo-600 hover:bg-indigo-700 transition-colors'
                                onClick={() => setshowPopup(true)}
                            >
                                {user?.admin_id ? "Change Admin" : "Assign Admin"}
                            </button>
                        )}
                        {user?.can_edit === 0 && (
                            <button 
                                className='px-[1.5vmax] py-[0.5vmax] rounded-lg text-[0.9vmax] font-bold text-white bg-emerald-600 hover:bg-emerald-700 transition-colors'
                                onClick={handleProfileEditing}
                                disabled={loading}
                            >
                                Allow Profile Editing
                            </button>
                        )}
                        <Link 
                            to={`/edit-profile/other-user-details?user_id=${user?.id}`}
                            className="px-[1.5vmax] py-[0.5vmax] rounded-lg text-[0.9vmax] font-bold text-white bg-amber-600 hover:bg-amber-700 transition-colors"
                        >
                            Update All Details
                        </Link>
                    </div>
                </div>
            )}

        </div>
    )
}

export default Profile